import StepPatient from './step-patient';

export default StepPatient;
